import { Link, useLocation } from 'react-router-dom';

export default function NoPermission() {
  const location = useLocation();
  const from =
    typeof location.state === 'object' &&
    location.state &&
    'from' in location.state &&
    typeof (location.state as { from?: { pathname?: string } }).from?.pathname === 'string'
      ? (location.state as { from: { pathname: string } }).from.pathname
      : '';

  return (
    <div className="flex flex-col items-center justify-center flex-1 px-4 py-20 text-center">
      <div className="w-16 h-16 rounded-full bg-background-100 flex items-center justify-center mb-5">
        <i className="ri-lock-line text-3xl text-foreground-400" />
      </div>
      <h1 className="text-xl font-semibold text-foreground-900">没有访问权限</h1>
      <p className="mt-2 text-sm text-foreground-500 max-w-md">
        当前账号无权访问该页面
        {from ? (
          <>
            （<span className="font-mono text-foreground-600">{from}</span>）
          </>
        ) : null}
        ，如需开通请联系管理员。
      </p>
      <Link
        to="/goods"
        className="mt-6 inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-white text-sm hover:bg-primary-600 transition-colors"
      >
        <i className="ri-home-4-line" />
        返回物资首页
      </Link>
    </div>
  );
}
